import { createGlobalStyle } from 'styled-components'
// eslint-disable-next-line import/no-unresolved
import { PancakeTheme } from '@pancakeswap-libs/uikit'

declare module 'styled-components' {
  /* eslint-disable @typescript-eslint/no-empty-interface */
  export interface DefaultTheme extends PancakeTheme {}
}

const GlobalStyle = createGlobalStyle`
  @import url('https://fonts.googleapis.com/css2?family=Happy+Monkey&display=swap');
  @import url('https://fonts.googleapis.com/css2?family=Galada&display=swap');
  * {
    font-family: 'Happy Monkey', cursive;
    font-weight: 400 !important;
  }
  body {
    background: url(../images/bg.jpg) ${({ theme }) => theme.colors.background};

    img {
      height: auto;
      max-width: 100%;
    }
  }
  *::-webkit-scrollbar {
    width: 5px;
  }
  *::-webkit-scrollbar-thumb {
    background: #141259;
    border-radius: 8px;
  }
  .hvd_comic_serif {
    font-weight: 400;
  }
  .dash_subheading {
    font-size: 20px;
  }
  .white_box {    
    box-shadow: -4px 5px 10px 2px rgb(0 0 0 / 20%);
    background-color: #ffffff !important;
  }
  .largeTitle {
    background: transparent;
    box-shadow: none;
    font-size: 34px !important;
    font-weight: 600 !important;
    font-family: 'Galada', cursive !important;
}
  .vision_card_panel {
    max-width: 600px;
    margin: 10px auto 0;
  }
  .menulink  div {
    font-size: 18px;
    text-transform: uppercase;
  }
  div[role="button"] a {
    text-transform: uppercase;
    font-size: 15px;
  }
  button div {
    font-family: "HVD_Comic_Serif_Pro";
    font-weight: 400 !important;
    font-size: 18px !important;
    color: #141259 !important;
  }
  button {
    font-family: HVD_Comic_Serif_Pro !important;
    font-weight: 400 !important;
  }
  .header_btn {
    padding: 22px 40px;
    font-size: 18px;
  }
  .toggle_wrapper > div:nth-child(2) {
    background-color: ${({ theme }) => theme.colors.card};
    border-radius: 30px;
  }
  .toggle_wrapper > div div:first-child {
    background-color: ${({ theme }) => theme.colors.card};
  }
  .toggle_wrapper > div div:first-child div {
    background-color: #141259;
    box-shadow: none !important;
  }
  button.farms_unlock_btn {
    width: 200px;
    height: 48px;
  }
  button.toggle_btn {
    box-shadow: none !important;
  }
  button {
    box-shadow: none !important;
  }
  .landingLogo{
    font-size: 0;
    background: url(../../images/logoLanding.png) no-repeat scroll 0 0;
    width: 519px;
    height: 97px;
    display: inline-block;
  }
  @media screen and (max-width: 559px) {
    .toggle_wrapper {
      display: block !important;
      text-align: center;
    }
    .toggle_wrapper > div {
      margin-bottom: 15px;
    }
    .landingLogo{
      background: url(../../images/logoLandingMobile.png) no-repeat scroll 0 0;
      width: 300px;
      height: 56px;
      display: inline-block;
    }
    .dash_subheading{
      font-size: 16px;
    }
  }
`

export default GlobalStyle
